import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

const FALLBACK = {
  jewelry: "https://images.unsplash.com/photo-1673131158656-84601f4d00ea?crop=entropy&cs=srgb&fm=jpg&q=85",
  men: "https://images.unsplash.com/photo-1754315249684-503bcc3b0dcf?crop=entropy&cs=srgb&fm=jpg&q=85",
  women: "https://images.unsplash.com/photo-1746207067926-52021271f372?crop=entropy&cs=srgb&fm=jpg&q=85",
};
const PANELS = [
  { key: "jewelry", label: "JEWELRY" },
  { key: "men", label: "ÉVAREN MEN" },
  { key: "women", label: "ÉVAREN WOMEN" },
];

export default function CategorySelect() {
  const { setStorefront, setEntered } = useApp();
  const navigate = useNavigate();
  const [images, setImages] = useState(FALLBACK);

  useEffect(() => {
    Promise.all(PANELS.map((p) =>
      api.get(`/storefront/${p.key}/bootstrap`)
        .then((r) => ({ key: p.key, img: (r.data.storefront?.category_image) || (r.data.homepage?.[0]?.image) || FALLBACK[p.key] }))
        .catch(() => ({ key: p.key, img: FALLBACK[p.key] }))
    )).then((res) => {
      const map = { ...FALLBACK };
      res.forEach((x) => { map[x.key] = x.img; });
      setImages(map);
    });
  }, []);

  const choose = (key) => {
    setStorefront(key);
    setEntered(true);
    navigate("/");
  };

  return (
    <motion.div
      data-testid="category-select"
      initial={{ opacity: 0 }} animate={{ opacity: 1 }}
      transition={{ duration: 0.7 }}
      className="fixed inset-0 z-[90] flex flex-col md:flex-row"
      style={{ background: "#0F2F24" }}
    >
      {PANELS.map((p, i) => (
        <motion.button
          key={p.key}
          data-testid={`category-${p.key}`}
          onClick={() => choose(p.key)}
          initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.15 + i * 0.12 }}
          className="group relative flex-1 overflow-hidden focus:outline-none"
        >
          <img src={images[p.key]} alt={p.label}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
          {/* Dior-style interactive dark overlay: dark by default, brightens on hover/tap of this panel only */}
          <div className="absolute inset-0 bg-[#0A1C16]/55 group-hover:bg-[#0A1C16]/5 active:bg-[#0A1C16]/10 transition-colors duration-[550ms]" />
          <div className="absolute inset-x-0 bottom-0 h-1/2 pointer-events-none"
            style={{ background: "linear-gradient(to top, rgba(10,28,22,0.82) 0%, rgba(10,28,22,0) 100%)" }} />
          <div className="absolute inset-x-0 bottom-0 pb-[12vh] md:pb-20 flex flex-col items-center text-center px-6">
            <span className="font-serif tracking-[0.12em] mb-3" style={{ color: "#F3EBDD", fontSize: "clamp(1.4rem,2.4vw,2rem)" }}>
              {p.label}
            </span>
            <span className="border-b pb-0.5 transition-all duration-500 group-hover:tracking-[0.28em]"
              style={{ color: "rgba(243,235,221,0.8)", borderColor: "rgba(243,235,221,0.5)", fontSize: "0.55rem", letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 600 }}>
              Shop Now
            </span>
          </div>
        </motion.button>
      ))}

      {/* Centered wordmark with soft radial shadow behind */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="absolute" style={{ width: "min(92vw,920px)", height: "min(52vh,380px)",
          background: "radial-gradient(ellipse at center, rgba(8,20,15,0.66) 0%, rgba(8,20,15,0.32) 38%, rgba(8,20,15,0) 68%)" }} />
        <motion.div
          initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="relative text-center px-6">
          <div className="font-serif leading-none"
            style={{ color: "#FFFDF8", fontSize: "clamp(2.4rem,6vw,5rem)", letterSpacing: "0.18em", textShadow: "0 2px 30px rgba(0,0,0,0.55)" }}>
            MAISON ÉVAREN
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
}
